<script setup>
import { scrollToTitle } from "@/composables/commonFunction.js";
const seoTitle = "MIRASOFT - Our Locations";
const seoDescription = "";

useHead({
  title: seoTitle,
  meta: [
    { name: "description", content: seoDescription },
    { name: "og:title", content: seoTitle },
    { name: "og:description", content: seoDescription },
    { name: "keywords", content: "Our Locations" },
  ],
});
</script>

<template id="contact-us">
  <div class="px-12 max-md:px-6 py-10">
    <Map />
    <section class="mt-[80px] 2xl:container m-auto">
      <div class="max-xl:hidden absolute ml-12 -mt-16 max-2xl:mt-0 max-2xl:ml-0 max-2xl:w-[70px]">
        <nuxt-picture
          loading="lazy"
          src="/images/like.svg"
          :imgAttrs="{ class: 'w-full', alt: 'home-banner' }"
          class="w-full"
        />
      </div>
      <h1 class="pb-5 font-extrabold heading-1" data-aos="fade-up">Your business</h1>
      <h1 class="pb-5 font-extrabold heading-1" data-aos="fade-up">Partner in trust</h1>
      <div class="flex max-lg:flex-col max-md:items-center gap-4" data-aos="fade-up">
        <div
          class="w-[65%] max-lg:w-full justify-center items-center max-lg:order-1"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div class="max-lg:hidden items-end gap-4 max-sm:flex-col max-sm:items-start">
            <nuxt-picture
              loading="lazy"
              src="/images/img.png"
              :imgAttrs="{ alt: 'hero', class: 'w-full' }"
              class="w-full"
            />
          </div>
          <div class="lg:hidden">
            <nuxt-picture
              loading="lazy"
              src="/images/bg-1.png"
              :imgAttrs="{ class: 'w-full', alt: 'home-banner-mobile' }"
              class="w-full"
            />
          </div>
        </div>
        <div class="w-[35%] max-lg:w-full bg-white p-6 rounded-3xl max-lg:my-5" data-aos="fade-up" data-aos-delay="300">
          <div class="px-10 max-md:px-0 max-lg:px-32 max-xl:px-1">
            <div class="mt-36 max-md:mt-0 max-lg:mt-10 max-xl:mt-20">
              <h4 class="font-semibold text-[36px] max-md:text-[20px] text-black">HEADQUARTERS</h4>
            </div>
            <div class="gap-2 mt-[54px] max-md:mt-10">
              <p class="text-[18px] max-md:text-[14px]">
                4th Floor - GTC Building, No. 69, To Huu Street, Van Phuc, Ha Dong, Hanoi
              </p>
              <p class="text-[18px] max-md:text-[14px] py-2">Hotline: +84 935 10 3636</p>
              <p class="text-[18px] max-md:text-[14px]">Email : contact@mirasoft.tech</p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex max-lg:flex-col max-md:items-center gap-4 pt-5" data-aos="fade-up">
        <div class="w-[40%] max-lg:w-full bg-white p-6 rounded-3xl max-lg:my-5" data-aos="fade-up" data-aos-delay="300">
          <div class="px-10 max-md:px-0 max-lg:px-36 max-xl:px-5">
            <div class="mt-36 max-md:mt-0 max-lg:mt-10 max-xl:mt-14">
              <h4 class="font-semibold text-[36px] max-md:text-[20px] text-black uppercase">ho chi minh branch</h4>
            </div>
            <div class="gap-2 mt-[54px] max-md:mt-10">
              <p class="text-[18px] max-md:text-[14px]">
                211, 9A Trung Son Street, Binh Hung Ward, Binh Chanh District, Ho Chi Minh City, Vietnam
              </p>
              <p class="text-[18px] max-md:text-[14px] py-2">Hotline :+84 24 36 436 999</p>
              <p class="text-[18px] max-md:text-[14px]">Email : contact@mirasoft.tech</p>
            </div>
          </div>
        </div>
        <div class="w-[60%] max-lg:w-full justify-center items-center" data-aos="fade-up" data-aos-delay="200">
          <div class="max-lg:hidden items-end gap-4 max-sm:flex-col max-sm:items-start">
            <nuxt-picture loading="lazy" src="/images/bg.png" :imgAttrs="{ alt: 'hero', class: 'w-full' }" />
          </div>
          <div class="lg:hidden">
            <nuxt-picture
              loading="lazy"
              src="/images/img-1.png"
              :imgAttrs="{ class: 'w-full', alt: 'home-banner-mobile' }"
              class="w-full"
            />
          </div>
        </div>
      </div>
    </section>

    <Excellence class="mt-[80px]" />
  </div>
</template>
